module.exports = __webpack_public_path__ + "icon-truck.d2bd23704c2df83e42356596c4928124.svg";